import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=3a15de7a&scoped=true&"
import script from "./Configurations.vue?vue&type=script&lang=ts&"
export * from "./Configurations.vue?vue&type=script&lang=ts&"
import style0 from "./Configurations.vue?vue&type=style&index=0&id=3a15de7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15de7a",
  null
  
)

export default component.exports